var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-wrapper',{staticClass:"history"},[_c('app-wrapper',{staticClass:"history-content",attrs:{"content":true,"text":true,"center":true}},[_c('h2',[_vm._v(_vm._s(_vm.$state.page.history_title))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$state.page.history_text)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }